import type { ColumnType } from 'antd/lib/table'
import React from 'react'
import styled from 'styled-components'
import { ResidentCell } from '../../molecules/Table/cells'
import type { ResidentCellProps } from '../../molecules/Table/cells/ResidentCell'
import Table from '../../molecules/Table/Table'
import DotCell, { type DotCellProps } from './components/DotCell'
import HeaderCell from './components/HeaderCell'

// temaMember & key are required
export type TrainingRow = {
  teamMember: ResidentCellProps
  key: string
} & {
  [key in string]?: DotCellProps | string | ResidentCellProps
}
export type TrainingColumn = {
  title: string | undefined
  status: string
  key: string | undefined
  dataIndex: string
}

type TrainingMatrixProps = {
  rows: TrainingRow[]
  columns: TrainingColumn[]
  loading?: boolean
  className?: string
}

const FIXED_CELLS_CLASS =
  'ant-table-cell.ant-table-cell-fix-left.ant-table-cell-fix-left-last'

const TableStyled = styled(Table)`
  .${FIXED_CELLS_CLASS} {
    border-right: 1px solid #f0f0f0;
  }
` as typeof Table

const getColumns = (columns: TrainingColumn[]): ColumnType<TrainingRow>[] => [
  {
    key: 'teamMember',
    dataIndex: 'teamMember',
    title: 'Team Member',
    align: 'left',
    fixed: 'left',
    render: (value: ResidentCellProps) => (
      <ResidentCell avatarSize={30} {...value} />
    )
  },
  ...columns.map(
    (column) =>
      ({
        align: 'center',
        width: 82.57,
        render: (_, record) => (
          <DotCell {...(record[column.dataIndex] as DotCellProps)} />
        ),
        title: <HeaderCell title={column.title} status={column.status} />
      }) as ColumnType<TrainingRow>
  )
]

function TrainingMatrix(props: TrainingMatrixProps) {
  const { rows, columns, loading, className } = props

  return (
    <TableStyled<TrainingRow>
      className={className}
      columns={getColumns(columns)}
      dataSource={rows}
      loading={loading}
      scroll={{ x: true }}
    />
  )
}

export default TrainingMatrix
